import { useMutation } from 'react-query';

import { unconfidentialProject } from 'shared/api/projects/http';

const useMutateUnconfidentialProject = (options = undefined) => useMutation((id) => unconfidentialProject(id), options);

export default useMutateUnconfidentialProject;
